import { PieChart } from '@mui/x-charts/PieChart'
import { Box } from '@mui/material'
import PieCenterLabel from './PieCenterLabel'
import PieLegendList from './PieLegendList'

const PACKAGE_COLORS = ['#4CAF50', '#2196F3', '#FF9800']

interface Props {
  data: { category: string; count: number; percentage: number }[]
}

const ServiceTypeMixChart = ({ data }: Props) => {
  if (!data || data.length === 0) return null

  const total = data.reduce((sum, item) => sum + item.count, 0)

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <PieChart
          series={[
            {
              innerRadius: 50,
              outerRadius: 80,
              cx: 100,
              cy: 100,
              data: data.map((item, idx) => ({
                id: idx,
                value: item.count,
                color: PACKAGE_COLORS[idx % PACKAGE_COLORS.length]
              }))
            }
          ]}
          width={200}
          height={200}
          margin={{ top: 5, bottom: 5, left: 5, right: 5 }}
          slotProps={{ legend: { hidden: true } }}
        >
          <PieCenterLabel primary='Total Booking' secondary={total.toLocaleString('id-ID')} />
        </PieChart>
      </Box>
      <PieLegendList
        items={data.map((item, idx) => ({
          color: PACKAGE_COLORS[idx % PACKAGE_COLORS.length],
          label: item.category,
          value: `${item.percentage.toFixed(1)}%`
        }))}
      />
    </Box>
  )
}

export default ServiceTypeMixChart
